/******INDEX******/

/***GENERAL***/
import React from "react";
import ReactDOM from "react-dom";
import App from "./01-App";

/***STYLE***/
import "./style/01-index.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);
